export default __webpack_public_path__ + "assets/images/eded7647a280b0e2443266643ca45c42.png";